import {FlexBrandItemFragment, useBrandItemUpdateMutation} from "../../Queries";
import {Box, Button} from "@mui/material";
import * as React from "react";
import {format} from 'date-fns';
import {BodyText} from "../../layout/Typography";
import {Dialogs} from "../../DialogProvider";

type TakeActionProps = {
   item?: FlexBrandItemFragment
   context?: {
      reloadRows?: (ids: string[]) => void
   }
}

export const BrandItemTakeActionColumn = ({item, context}: TakeActionProps) => {
   const [updateItem] = useBrandItemUpdateMutation();

   const unsolvedProblems = item?.problems?.filter(problem =>
      problem && !problem.solved && problem.description
   ) || [];

   if (unsolvedProblems.length === 0) {
      return null;
   }

   const handleSolveProblem = async (problemIndex: number) => {
      if (!item?._id || !item?.brandHouseId) {
         return;
      }

      // Create updated problems array with the specific problem marked as solved
      const updatedProblems = (item.problems || []).map((problem, index) => {
         const originalIndex = item.problems?.indexOf(unsolvedProblems[problemIndex]);
         if (index === originalIndex) {
            return {
               description: problem?.description || '',
               createdAt: problem?.createdAt,
               solved: true
            };
         }
         return {
            description: problem?.description || '',
            createdAt: problem?.createdAt,
            solved: problem?.solved || false
         };
      });

      await updateItem({
         variables: {
            brandHouseId: item.brandHouseId,
            input: {
               _id: item._id,
               problems: updatedProblems
            }
         }
      });

      // Reload the row in the RangeList
      context?.reloadRows?.([item._id]);
   };

   return (
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
         {unsolvedProblems.map((problem, index) => (
            <Box key={index} sx={{display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'space-between'}}>
               <Box sx={{display: 'flex', gap: 1, overflow: 'hidden', minWidth: 0}}>
                  <BodyText type="body2" sx={{color: '#a0a0a0', whiteSpace: 'nowrap'}}>
                     {problem?.createdAt ? format(new Date(problem.createdAt), 'yyyy-MM-dd') : ''}
                  </BodyText>
                  <BodyText type="body2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} title={problem?.description || ''}>
                     {problem?.description}
                  </BodyText>
               </Box>
               <Button
                  variant="outlined"
                  size="small"
                  onClick={async (e) => {
                     e.stopPropagation();
                     e.preventDefault();
                     Dialogs.confirm({
                        title: 'Solve problem',
                        subtitle: 'Are you sure you want to solve this problem?',
                        buttonYes: 'Solve',
                        buttonNo: 'Cancel'
                     }, async () => handleSolveProblem(index))
                  }}
                  sx={{minWidth: 'auto', whiteSpace: 'nowrap'}}
               >
                  Solve
               </Button>
            </Box>
         ))}
      </Box>
   );
};